<template>
    <div>
      <div class="page-header">
        <div class="page-icon">⚠️</div>
        <h2>补货通知</h2>
        <span class="page-desc">{{ today.format('YYYY-MM-DD') }}</span>
      </div>
      <el-card class="box-card" v-if="restockItems.length > 0">
        <el-table :data="restockItems" stripe>
          <el-table-column label="商品名称" prop="product_name"></el-table-column>
          <el-table-column label="盈亏" prop="profit_loss">
            <template #default="{ row }">
              <span style="color: #ff4949">{{ row.profit_loss }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前库存数量" prop="current_stock"></el-table-column>
          <el-table-column label="操作">
            <template #default="{ row }">
              <el-button type="primary" size="small" @click="goToRestock(row.product_name)">去补货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div v-else>
        <p>今天暂无需要补货的商品。</p>
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import dayjs from 'dayjs';
  import { useRestockStore } from '@/store/restock';
  
  const router = useRouter();
  const restockStore = useRestockStore();
  
  // 当前日期（动态获取）
  const today = dayjs();
  
  // 从 Pinia 获取补货数据
  const restockItems = computed(() => restockStore.items);
  
  // 跳转到补货页面
  const goToRestock = (productName) => {
    router.push({ path: '/BatchProduct-Entry', query: { product: productName } });
  };
  </script>
  
  <style scoped>
h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.box-card {
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
  padding: 20px;
  margin-top: 8px;
  border: 1px solid var(--border-lighter);
}

.empty-state {
  background: var(--success-light);
  color: var(--success);
  padding: 50px 0;
  text-align: center;
  border-radius: var(--radius-md);
  font-size: 16px;
  border: 1px solid #c2e7b0;
}
</style>
